import {MOON_500} from '@wandb/weave/common/css/color.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {TooltipDeprecated} from '@wandb/weave/components/TooltipDeprecated';
import React from 'react';

import {Analytics} from '../../services/analytics';
import DOC_URLS from '../../util/doc_urls';
import {WBTableRowWithRunSetInfo} from '../../util/tablecols';
import {useFetchRunJob} from '../Launch/hooks';
import {JobInfo} from '../Launch/utilTypes';

interface LaunchJobIconProps {
  projectName: string;
  entityName: string;
  row: WBTableRowWithRunSetInfo;
  setLaunchDrawerRow: (name: string, jobInfo: JobInfo) => void;
}

const trackLaunchIconClicked = ({
  entityName,
  projectName,
  runName,
  jobID,
}: {
  entityName: string;
  projectName: string;
  runName: string;
  jobID: string;
}) => {
  Analytics.track('Runs table launch', {
    entityName,
    projectName,
    runName,
    jobID,
  });
};

const LaunchJobIcon = (props: LaunchJobIconProps) => {
  const {projectName, entityName, row, setLaunchDrawerRow} = props;

  const {jobInfo, loading, error} = useFetchRunJob({
    entityName,
    projectName,
    runName: row.name,
    skip: false,
  });

  if (loading || error) {
    return <></>;
  }

  return (
    <LaunchJobIconInner
      row={row}
      setLaunchDrawerRow={setLaunchDrawerRow}
      projectName={projectName}
      entityName={entityName}
      jobInfo={jobInfo}
    />
  );
};

interface LaunchJobIconInnerProps {
  row: WBTableRowWithRunSetInfo;
  setLaunchDrawerRow: (name: string, jobInfo: JobInfo) => void;
  projectName: string;
  entityName: string;
  jobInfo: JobInfo | null;
}

const LaunchJobIconInner = (props: LaunchJobIconInnerProps) => {
  const {row, setLaunchDrawerRow, projectName, entityName, jobInfo} = props;
  const toolTipContent =
    jobInfo != null ? (
      <div>Clone with launch</div>
    ) : (
      <div>
        Cannot be cloned with Launch. No{' '}
        <TargetBlank
          style={{font: 'semibold', color: 'inherit'}}
          href={DOC_URLS.launchJobs}>
          jobs
        </TargetBlank>{' '}
        are associated with the run.
      </div>
    );

  return (
    <div
      className="launch-run-icon"
      style={{
        justifyContent: 'right',
        display: 'flex',
        flex: 1,
      }}>
      <TooltipDeprecated
        hoverable
        trigger={
          <span>
            <Button
              data-test="launch-icon"
              disabled={jobInfo == null}
              icon="rocket-launch"
              variant="ghost"
              style={{color: MOON_500}}
              onClick={() => {
                if (jobInfo != null) {
                  trackLaunchIconClicked({
                    entityName,
                    projectName,
                    runName: row.name,
                    jobID: jobInfo.id,
                  });
                  setLaunchDrawerRow(row.name, jobInfo);
                }
              }}
            />
          </span>
        }>
        {toolTipContent}
      </TooltipDeprecated>
    </div>
  );
};

export default LaunchJobIcon;
